import { buildUser, ResponseUser } from '@/shared/types/entities/User';
import { State } from '../index';
import { AUTH_MUTATION } from './mutationTypes';

export const authMutations = {
  [AUTH_MUTATION.LOGIN]: (state: State, user: ResponseUser) => {
    state.auth.user = buildUser(user);
  },
  [AUTH_MUTATION.LOGOUT]: (state: State) => {
    state.auth.user = undefined;
  },
  [AUTH_MUTATION.GET_USER]: (state: State, user: ResponseUser) => {
    state.auth.user = buildUser(user);
  },
};
